import React, { useEffect } from 'react';
import { Select, Button, Input, } from 'antd';
import styles from './index.less';

export default function FilterDropdown(props) {
  const { isMultiple, setSelectedKeys, selectedKeys, visible, confirm, clearFilters, data, onSearch, placeholder, that } = props;

  useEffect(() => {
  }, [])
  return (
    <div style={{ padding: 8 }} className={styles.FilterDropdown}>
      <Button
        type="primary"
        onClick={() => { onSearch && onSearch(selectedKeys, confirm) }}
        icon="search"
        size="small"
        style={{ width: 90, marginRight: 8, marginBottom: 8 }}
        key='search'
      >
        查询
      </Button>
      <Button key='reset' onClick={() => { clearFilters() }} size="small" style={{ width: 90, marginBottom: 8 }}>
        重置
      </Button>
      <Select
        // ref={node =>{ that.selectInput = node  }}
        // autoFocus={true}
        onSearch={() => { }}
        showSearch
        open={visible}
        value={isMultiple ? (selectedKeys || []) : (selectedKeys || undefined)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={(value, option) => {
          if (isMultiple) {
            setSelectedKeys(value);
          } else {
            setSelectedKeys(value ? [value] : [])
            onSearch && onSearch(selectedKeys, confirm)
          }
        }}
        mode={isMultiple && 'multiple'}
        placeholder={placeholder}
      >
        {data && data.map((item) => {
          return <Select.Option key={item.key || item.id} value={`${item.id}`}>{item.name}</Select.Option>
        })}
      </Select>

    </div>
  )
}
